

























import { defineComponent, ref } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'FeedbackButton',
  components: {
    SfButton
  },
  props: {
    small: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false }
  },
  setup(_, { emit }) {
    const ADD_TIMEOUT_MS = 2000;
    const isAdding = ref(false);
    const contentContainerElement = ref(null);

    const handleButtonClick = () => {
      if (isAdding.value) return;
      // set button width to prevent content from shifting
      contentContainerElement.value.style.width = `${contentContainerElement.value.offsetWidth}px`;
      isAdding.value = true;
      emit('click');
      setTimeout(() => {
        isAdding.value = false;
        // reset button width
        contentContainerElement.value.style.width = 'auto';
      }, ADD_TIMEOUT_MS);
    };

    return {
      isAdding,
      contentContainerElement,
      handleButtonClick
    };
  }
});
